import React, { useEffect, useState } from "react";

import { Box, Typography } from "@mui/material";
import { Title } from "../Components/Order/Title/Title";
import { CollapseProductDetail } from "../Components/Order/Form/OrderDetail/OrderForm";
import { OrderForm } from "../Components/Order/Form/OrderDetail/OrderForm/DetailForm";
import { MetaFieldForm } from "../Components/Order/Form/OrderDetail/MetaFieldForm/MetaFieldForm";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getSingleOrder } from "../Store/Features/SingleOrder/SingleOrder";
import CircularProgress from '@mui/material/CircularProgress';



export const Order = () => {
  const dispatch = useDispatch();
  const { slug } = useParams();
  const Order = useSelector(state => state.singleOrderSlice.value);
  const Loading = useSelector(state => state.singleOrderSlice.loading);
  useEffect(() => {
    dispatch(getSingleOrder(slug));
  }, []);


  return (
    <Box className="main_container df-c-20">
      {Loading ? (<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", justifyContent: "center", height: "80vh" }}><CircularProgress /></Box>) : (
        <>
          <Title Title={Order.id} />
          <Box className="df-c-20">
            <CollapseProductDetail Title="Order Details">
              <OrderForm {...Order} />
            </CollapseProductDetail>
            <CollapseProductDetail Title="Metafields">
              <MetaFieldForm {...Order} />
            </CollapseProductDetail>
          </Box>
        </>)
      }
    </Box>
  );
};